import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, InputNumber, Button, Row, Col, Typography, Space } from "antd";
import { toast } from "../../components/toasts/toastStore";
import SuccessOverlay from "../../components/feedback/SuccessOverlay";
import { apiServiciosInstance, authHeaderServicios } from "../../redux/actions/serviciosPrecios/serviciosPrecios";

import "./PacientesPage.css";

const { Title, Text } = Typography;

export default function CrearServicioPage() {
  const navigate = useNavigate();
  const { id_servicio } = useParams();
  const isEditing = !!id_servicio;

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [loadingItem, setLoadingItem] = useState(isEditing);
  const [success, setSuccess] = useState({ show: false, title: "", subtitle: "", to: "/app/servicios" });

  useEffect(() => {
    if (!isEditing) return;
    setLoadingItem(true);
    apiServiciosInstance
      .get(`/servicios-precios/${id_servicio}`, { headers: authHeaderServicios() })
      .then((res) => {
        const item = res.data ?? {};
        form.setFieldsValue({
          nombre: item.nombre,
          precio_lista: item.precio_lista != null ? Number(item.precio_lista) : null,
        });
      })
      .catch(() => toast.error("No se pudo cargar el servicio"))
      .finally(() => setLoadingItem(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_servicio]);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      nombre: values.nombre?.trim(),
      precio_lista: Number(values.precio_lista),
    };

    setSaving(true);
    try {
      if (isEditing) {
        await apiServiciosInstance.put(`/servicios-precios/${id_servicio}`, payload, { headers: authHeaderServicios() });
        setSuccess({ show: true, title: "Servicio actualizado", subtitle: "Los cambios se guardaron correctamente.", to: `/app/servicios/${id_servicio}` });
      } else {
        const { data } = await apiServiciosInstance.post("/servicios-precios", payload, { headers: authHeaderServicios() });
        setSuccess({ show: true, title: "Servicio creado", subtitle: "Se registró correctamente en el catálogo.", to: `/app/servicios/${data?.id}` });
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "No se pudo guardar el servicio");
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="paq-title" style={{ marginBottom: 0 }}>
              {isEditing ? "Editando servicio" : "Nuevo servicio"}
            </Title>
            <Text className="paq-subtitle">
              {isEditing
                ? "Modifica los datos del servicio y guarda los cambios."
                : "Completa los datos para registrarlo en el catálogo."}
            </Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate(-1)} disabled={saving || success.show}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={saving}
              disabled={success.show || loadingItem}
              icon={!isEditing ? <i className="fa-solid fa-plus" /> : null}
              onClick={handleSave}
              style={{ backgroundColor: "var(--brand-primary)", borderColor: "var(--brand-primary)" }}
            >
              {isEditing ? "Guardar cambios" : "Crear servicio"}
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical" disabled={loadingItem}>
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-tags" /></span>
              Datos del servicio
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="nombre"
                  label={<span className="paq-field-label">Nombre</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Ej. Consulta general" maxLength={150} autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="precio_lista"
                  label={<span className="paq-field-label">Precio de lista</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <InputNumber style={{ width: "100%" }} min={0} precision={2} placeholder="0.00" addonBefore="$" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>

      <SuccessOverlay
        show={success.show}
        title={success.title}
        subtitle={success.subtitle}
        onDone={() => navigate(success.to)}
      />
    </main>
  );
}
